import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eec47d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-customer-review" }
const _hoisted_2 = { class: "frisbuy-customer-review__customer-info" }
const _hoisted_3 = { class: "frisbuy-customer-review__customer-name" }
const _hoisted_4 = {
  key: 0,
  class: "frisbuy-customer-review__customer-rating"
}
const _hoisted_5 = { class: "frisbuy-customer-review__source" }
const _hoisted_6 = { class: "frisbuy-customer-review__date" }
const _hoisted_7 = ["datetime"]
const _hoisted_8 = { class: "frisbuy-customer-review__time" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-customer-review__time-preposition" }, " в ", -1))
const _hoisted_10 = { class: "frisbuy-customer-review__time-numbers" }
const _hoisted_11 = {
  key: 0,
  class: "frisbuy-customer-review__marketplace"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-customer-review__marketplace-preposition" }, " на ", -1))
const _hoisted_13 = { class: "frisbuy-customer-review__marketplace-name" }
const _hoisted_14 = {
  key: 0,
  class: "frisbuy-customer-review__product-info"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "product-info-prefix" }, "К товару:", -1))
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 0,
  class: "frisbuy-customer-review__text--positive"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.7633 12.51C21.157 11.9897 21.375 11.3522 21.375 10.6889C21.375 9.63654 20.7867 8.64045 19.8398 8.08498C19.5961 7.942 19.3185 7.86675 19.0359 7.86701H13.4156L13.5563 4.98654C13.5891 4.29045 13.343 3.62951 12.8648 3.1256C12.6302 2.87723 12.3471 2.67962 12.0331 2.54497C11.7191 2.41033 11.3807 2.34152 11.0391 2.34279C9.82031 2.34279 8.74219 3.1631 8.41875 4.33732L6.40547 11.6264H6.39844V21.6576H17.468C17.6836 21.6576 17.8945 21.6154 18.0891 21.5311C19.2047 21.0553 19.9242 19.9654 19.9242 18.7561C19.9242 18.4608 19.882 18.1701 19.7977 17.8889C20.1914 17.3686 20.4094 16.7311 20.4094 16.0678C20.4094 15.7725 20.3672 15.4819 20.2828 15.2006C20.6766 14.6803 20.8945 14.0428 20.8945 13.3795C20.8898 13.0842 20.8477 12.7912 20.7633 12.51ZM2.625 12.3764V20.9076C2.625 21.3225 2.96016 21.6576 3.375 21.6576H4.89844V11.6264H3.375C2.96016 11.6264 2.625 11.9615 2.625 12.3764Z",
    fill: "black",
    "fill-opacity": "0.45"
  })
], -1))
const _hoisted_19 = {
  key: 1,
  class: "frisbuy-customer-review__text--negative"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.23672 11.4905C2.84297 12.0108 2.625 12.6483 2.625 13.3116C2.625 14.3639 3.21328 15.36 4.16016 15.9155C4.40392 16.0585 4.68146 16.1337 4.96406 16.1335H10.5844L10.4437 19.0139C10.4109 19.71 10.657 20.371 11.1352 20.8749C11.3698 21.1233 11.6529 21.3209 11.9669 21.4555C12.2809 21.5902 12.6193 21.659 12.9609 21.6577C14.1797 21.6577 15.2578 20.8374 15.5812 19.6632L17.5945 12.3741H17.6016V2.34285H6.53203C6.31641 2.34285 6.10547 2.38504 5.91094 2.46942C4.79531 2.9452 4.07578 4.03504 4.07578 5.24442C4.07578 5.53973 4.11797 5.83035 4.20234 6.1116C3.80859 6.63192 3.59063 7.26942 3.59063 7.9327C3.59063 8.22801 3.63281 8.51863 3.71719 8.79988C3.32344 9.3202 3.10547 9.9577 3.10547 10.621C3.11016 10.9163 3.15234 11.2093 3.23672 11.4905ZM21.375 11.6241V3.09285C21.375 2.67801 21.0398 2.34285 20.625 2.34285H19.1016V12.3741H20.625C21.0398 12.3741 21.375 12.0389 21.375 11.6241Z",
    fill: "black",
    "fill-opacity": "0.45"
  })
], -1))
const _hoisted_21 = {
  key: 2,
  class: "frisbuy-customer-review__text--comment"
}

import Vue3StarRating from "vue3-star-ratings";
import StarRounded from "@/widgets/MarketplaceReviews/Icons/StarRounded.vue";
import StarSoftRounded from "@/widgets/MarketplaceReviews/Icons/StarSoftRounded.vue";
import MediaList, { MediaListCustomization } from "./MediaList.vue";
import { imageWithPostId, postMedia } from "../interfaces";
import { onBeforeMount, ref, watch } from "vue";
import { addSchemaToPage } from "@/common/services/SchemaOrg/SchemaOrg";

//#region Schema.org
type sectionConfig = {
  order: number;
  margin: string;
};

type ProductLinkInfo = {
  link: string;
  title: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerReview',
  props: {
    customerName: {},
    reviewDate: {},
    reviewTime: {},
    reviewMarketplace: {},
    rating: {},
    mediaList: {},
    isShowMedia: { type: Boolean, default: true },
    negativeComment: {},
    positiveComment: {},
    text: {},
    blocksOrder: {},
    sectionsMarginTop: {},
    topSectionConfig: { default: () => {
      return {
        order: 0,
        margin: "0",
      };
    } },
    mediaSectionConfig: { default: () => {
      return {
        order: 1,
        margin: "20px 0 0 0",
      };
    } },
    textSectionConfig: { default: () => {
      return {
        order: 2,
        margin: "20px 0 0 0",
      };
    } },
    isSoftStarIcon: { type: Boolean }
  },
  emits: ["selectMedia"],
  setup(__props: any, { emit: __emit }) {

onBeforeMount(() => {
  props.mediaList?.forEach((media) => {
    media.linkList.forEach((link) => {
      const Product = link;
      const bestRating = 5;
      // NOTE: if ratingValue === 0 and worstRating === 1, then it will be error
      const worstRating = 1;
      if (!Product) {
        return;
      }

      /* NOTE:
        Google always need to get `ratingValue` and `reviewCount`.
        But sometimes this information may not be available
      */
      if (
        !Product.sku ||
        !Product.sku?.avgRating ||
        !Product.sku?.reviewsCount
      ) {
        return;
      }

      const reviewRating =
        props.rating && props.rating > 0 ? props.rating : bestRating;

      const SchemaorgProduct = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: Product.title,
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: Product.sku.avgRating,
          bestRating: bestRating,
          worstRating: worstRating,
          reviewCount: Product.sku.reviewsCount,
        },

        review: [
          {
            "@type": "Review",

            author: {
              "@type": "Person",
              name: props.customerName,
            },
            datePublished: props.reviewDate,
            reviewBody: `${props.text}\n${props.positiveComment}\n${props.negativeComment}`,

            reviewRating: {
              "@type": "Rating",
              bestRating: bestRating,
              ratingValue: reviewRating,
              worstRating: worstRating,
            },
          },
        ],
      };

      addSchemaToPage(SchemaorgProduct);
    });
  });
});
//#endregion Schema.org

const props = __props;

const emit = __emit;

function selectPostWithPhoto(media: imageWithPostId) {
  emit("selectMedia", media);
}

//#region unique product links
const uniqueProductLinks = ref<Array<ProductLinkInfo>>([]);
onBeforeMount(() => {
  uniqueProductLinks.value = getUniqueProductLinks();
});

watch(
  () => props.mediaList,
  () => {
    uniqueProductLinks.value = getUniqueProductLinks();
  }
);

function getUniqueProductLinks(): Array<ProductLinkInfo> {
  const uniqueLinks: Array<ProductLinkInfo> = [];
  const uniqueLinksInStringifyFormat = new Set<string>();

  props.mediaList?.forEach((media) => {
    media.linkList.forEach((link) => {
      const productInfo = {
        link: link.link,
        title: link.title,
      };

      uniqueLinksInStringifyFormat.add(JSON.stringify(productInfo));
    });
  });

  uniqueLinksInStringifyFormat.forEach((linkInStringifyFormat) => {
    uniqueLinks.push(JSON.parse(linkInStringifyFormat));
  });

  return uniqueLinks;
}
//#endregion unique product links

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "frisbuy-customer-review__top-section",
      style: _normalizeStyle({
        order: props.topSectionConfig.order,
        margin: props.topSectionConfig.margin,
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(props.customerName), 1)
        ]),
        (props.rating)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(Vue3StarRating), {
                modelValue: props.rating,
                numberOfStars: 5,
                starSize: 22,
                starColor: '#606266',
                inactiveColor: '#E9E9EB',
                disableClick: true,
                customSvg: _ctx.isSoftStarIcon ? StarSoftRounded : StarRounded
              }, null, 8, ["modelValue", "customSvg"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("time", {
            datetime: props.reviewDate
          }, _toDisplayString(props.reviewDate), 9, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(props.reviewTime), 1)
        ]),
        (props.reviewMarketplace)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(props.reviewMarketplace), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (uniqueProductLinks.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueProductLinks.value, (product) => {
              return (_openBlock(), _createElementBlock("span", {
                key: product.link
              }, [
                _createElementVNode("a", {
                  class: "product-info-link",
                  href: product.link
                }, [
                  _createElementVNode("span", null, _toDisplayString(product.title), 1)
                ], 8, _hoisted_16)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (props.isShowMedia && props.mediaList && props.mediaList.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "frisbuy-customer-review__media-section",
          style: _normalizeStyle({
        order: props.mediaSectionConfig.order,
        margin: props.mediaSectionConfig.margin,
      })
        }, [
          _createVNode(MediaList, {
            mediaList: props.mediaList,
            wrap: props.mediaSectionConfig.wrap,
            gap: props.mediaSectionConfig.gap,
            mediaWidth: props.mediaSectionConfig.mediaWidth,
            mediaHeight: props.mediaSectionConfig.mediaHeight,
            mediaAspectRatio: props.mediaSectionConfig.mediaAspectRatio,
            onSelectMedia: _cache[0] || (_cache[0] = (media) => selectPostWithPhoto(media))
          }, null, 8, ["mediaList", "wrap", "gap", "mediaWidth", "mediaHeight", "mediaAspectRatio"])
        ], 4))
      : _createCommentVNode("", true),
    (props.positiveComment || props.negativeComment || props.text)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "frisbuy-customer-review__text",
          style: _normalizeStyle({
        order: props.textSectionConfig.order,
        margin: props.textSectionConfig.margin,
      })
        }, [
          (props.positiveComment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", null, _toDisplayString(props.positiveComment), 1)
              ]))
            : _createCommentVNode("", true),
          (props.negativeComment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", null, _toDisplayString(props.negativeComment), 1)
              ]))
            : _createCommentVNode("", true),
          (props.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("span", null, _toDisplayString(props.text), 1)
              ]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})